<template>
  <v-container fluid>
    <v-row class="justify-between align-center">
      <v-col cols="auto" class="ml-auto">
        <v-text-field
          filled
          rounded
          dense
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-card outlined>
          <v-data-table
            :headers="headers"
            :items="activeCallsList"
            :loading="isLoadingTable"
            :search="search"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100]
            }"
          >
            <!-- <template v-slot:[`item.duration`]="{ item }">
          <span v-if="Boolean(item.duration)">
            {{ tem.duration | secondsToTimeFormat }}
          </span>
          <time-counter v-else :item="item"></time-counter>
        </template> -->
            <!-- <template v-slot:[`item.status`]="{ item }">
          {{ statusList[item.status] }}
        </template> -->
            <!-- <template v-slot:[`item.action`]="{ item }">
          <v-btn icon @click="openConfirmClose(item.id)">
            <v-icon>mdi-exit-to-app</v-icon>
          </v-btn>
        </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import moment from "moment";
import { PbxHttpClient } from "@/services/httpclient";
export default {
  data() {
    return {
      isLoading: false,
      isLoadingTable: true,
      isConfirmDialog: false,
      search: "",
      headers: [
        {
          text: "Canal",
          align: "left",
          value: "chan",

          width: "20%"
        },
        {
          text: "Contexto",
          align: "left",
          value: "context",

          width: "20%"
        },
        {
          text: "Aplicación",
          align: "left",
          value: "app",

          width: "10%"
        },
        {
          text: "Estado",
          value: "status",

          width: "10%"
        },
        {
          text: "Lado 1",
          value: "dst",

          width: "15%"
        },
        {
          text: "Lado 2",
          value: "src",

          width: "10%"
        },
        {
          text: "Duración",
          value: "duration",

          width: "10%"
        }
        // {
        //   text: "Acciones",
        //   value: "action",
        //   class: "primary--text",
        //   width: "10%",
        //   align: "center",
        //   sortable: false
        // }
        // { text: "", value: "data-table-expand", width: "5%" }
      ],
      activeCallsList: [],
      statusList: {
        0: "Eliminado",
        1: "Conectado",
        2: "Pausado",
        3: "Bloqueado"
      },
      pauseToDelete: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10
    };
  },
  async created() {
    await this.getActiveCalls();
  },
  methods: {
    openConfirmClose(pauseId) {
      this.pauseToDelete = pauseId;
      this.isConfirmDialog = true;
    },
    async getActiveCalls() {
      try {
        this.isLoadingTable = true;
        const { data } = await PbxHttpClient.get(
          "/server_externo/extension/activeCalls"
        );
        // console.log("agents", data.data);
        this.activeCallsList = data.data;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta", "Error");
        // console.log(error);
      } finally {
        this.isLoadingTable = false;
      }
    },
    async closePause() {
      this.isLoading = true;
      try {
        await PbxHttpClient.put(`/agent/use_pause/${this.pauseToDelete}`);
        // await new Promise((res, rej) => {
        //     setTimeout(() => {
        //         res("done");
        //     }, 2000);
        // });
        this.activeCallsList = this.activeCallsList.filter(
          (e) => e.pause_id !== this.pauseToDelete
        );
        this.pauseToDelete = null;
        this.$snotify.success("Pausa cerrada con éxito.", "¡Hecho!");
        this.isConfirmDialog = false;
      } catch (err) {
        this.$snotify.error("Hubo un error cerrando la pausa", "Error");
      }

      this.isLoading = false;
    }
  }
};
</script>

<style></style>
